import React from 'react';
import _ from 'lodash';
import Promise from 'bluebird';
import Parse from 'parse';
import { validEmail } from 'shared/models/user';
import FormField from 'shared/components/ui/formField';
import Button from 'shared/components/ui/button';

class ForgotPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
      error: null,
      errors: {},
      loading: false
    };
    this.model = {
      email: props.email || ''
    };
  }

  validateEmail(email) {
    if (!validEmail(email)) return 'Email is not valid';
  }

  validateFields() {
    const { email } = this.model;

    let errors = {};
    errors.email = this.validateEmail(email) || null;

    this.setState({ errors });

    if (_.some(errors)) return Promise.reject(new Error());
    return Promise.resolve();
  }

  _submit({ email }) {
    return new Promise((resolve, reject) => {
      Parse.User.requestPasswordReset(email, {
        success() {
          resolve();
        },
        error(err) {
          if (err) reject(new Error(err.message));
        }
      });
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true, error: null, success: false });
    this.validateFields()
      .then(() => this._submit(this.model))
      .then(() => this.setState({ success: true }))
      .catch(({ message }) => {
        this.setState({ loading: false, error: message });
      });
  }

  returnToLogin(e) {
    if (this.props.showLogin) {
      e.preventDefault();
      this.props.showLogin();
    }
  }

  render() {
    return (
      <form onSubmit={e => this.handleSubmit(e)} className="text-left">
        {this.state.error && <div className="warning">{this.state.error}</div>}

        <div className="row">
          <div className="col-xs-12">
            <FormField
              id="user-email"
              name="email"
              labelText="Email"
              inputType="email"
              initialValue={this.model.email}
              onChange={email => (this.model = { ...this.model, email })}
              validate={email => this.validateEmail(email)}
              error={this.state.errors.email}
            />
          </div>
        </div>

        {this.state.success ? (
          <div className="success">
            A password reset link has been sent.{' '}
            <a
              href="/login"
              className="link-text"
              onClick={e => this.returnToLogin(e)}
            >
              Return to Login.
            </a>
          </div>
        ) : (
          <div className="row">
            <div className="col-xs-12">
              <Button
                type="submit"
                className="btn-primary green btn--full-width"
                disabled={this.state.loading}
                loading={this.state.loading}
              >
                Reset Password
              </Button>
            </div>
          </div>
        )}
      </form>
    );
  }
}

export default ForgotPasswordForm;



// WEBPACK FOOTER //
// ./shared/components/login/forgot.js